import axios from "axios";
import React, { useEffect, useState } from "react";
import { Api_Url } from "../../config/config";
import { FaUpload } from "react-icons/fa6";
import { MdCancel, MdDelete, MdEdit } from "react-icons/md";
import { Modal } from "antd";
import { ErrorToast, SuccessToast } from "../../views/ToastComponent";

const PdExpense = ({ profileId }) => {
  const [expenseData, setExpenseData] = React.useState([]);
  const [formExpenseData, setFormExpenseData] = React.useState({
    Name: "",
    DescriptionText: "",
    Amount: 0,
    ImageUrl: null,
    Latitude: "",
    Longitude: "",
    BusinessPdProfileId: profileId,
    BusinessId: "",
    DescriptionValue: "",
  });
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);
  const [itemToDelete, setItemToDelete] = React.useState(null);

  const handleImageChange = (event) => {
    setFormExpenseData((prev) => ({
      ...prev,
      ImageUrl: event.target.files[0],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    fetchCurentLocation();

    const formData = new FormData();
    formData.append("Name", formExpenseData.Name);
    formData.append("DescriptionText", formExpenseData.DescriptionText);
    formData.append("Amount", formExpenseData.Amount);
    formData.append("ImageUrl", formExpenseData.ImageUrl);
    formData.append("Latitude", formExpenseData.Latitude);
    formData.append("Longitude", formExpenseData.Longitude);
    formData.append("BusinessPdProfileId", formExpenseData.BusinessPdProfileId);
    formData.append("BusinessId", formExpenseData.BusinessId);
    formData.append("DescriptionValue", formExpenseData.DescriptionValue);

    const { data } = await axios.post(Api_Url + "api/v1/PdExpense", formData, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
          "Content-Type": "multipart/form-data",
      },
    });
    if (data.succeeded) {
      fetchExpenseData();
      setIsModalOpen(false);
      setFormExpenseData((prev) => ({
        ...prev,
        Name: "",
        DescriptionText: "",
        Amount: 0,
        ImageUrl: null,
        Latitude: "",
        Longitude: "",
        BusinessPdProfileId: profileId,
        BusinessId: "",
        DescriptionValue: "",
      }));
    }
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const { data } = await axios.delete(
        Api_Url + "api/v1/PdExpense/" + itemToDelete,
        {
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user"))?.accessToken,
          },
        }
      );
      if (data.succeeded) {
        fetchExpenseData();
      }
      SuccessToast("Deleted Successfully");
    } catch (error) {
      ErrorToast("Something went wrong");
      console.log(error);
    } finally {
      setIsDeleteModalOpen(false);
      setItemToDelete(null);
    }
  };

  const fetchExpenseData = async () => {
    const { data } = await axios.get(
      Api_Url + `api/v1/PdExpense/getby-pd-profileid/${profileId}`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
        },
      }
    );
    setExpenseData(data.data);
  };

  const fetchCurentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setFormExpenseData((prev) => ({
          ...prev,
          Latitude: latitude.toString(),
          Longitude: longitude.toString(),
        }));
      });
    } else {
      return "Geolocation is not supported by this browser.";
    }
  };

  React.useEffect(() => {
    fetchExpenseData();
    fetchCurentLocation();
  }, []);

  // Single User 


  const [editFormData, setEditFormData] = useState({
    id:0,
    name: "",
    amount: 0,
    imageUrl: null,
    latitude: "",
    longitude: "",
  })


  
  const handleEditImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setEditFormData((prev) => ({
        ...prev,
        imageUrl: file,
      }));
    }
  };

  useEffect(()=>{
    Location()
  },[])


  const Location = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setEditFormData((prev) => ({
          ...prev,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
        }));
      });
    } else {
      return "Geolocation is not supported by this browser.";
    }
  };


  const HandleShowFunction = async(id) => {
    console.log(id)
    try {
      const response = await axios.get(`${Api_Url}api/v1/PdExpense/${id}`,{
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user"))?.accessToken,
        },
      })
      setEditFormData(response?.data?.data)
      setIsEditModalOpen(true)
    } catch (error) {
      console.log(error)
    }
  }


  // Update Method
  const handleUpdate = async (id) => {
    Location();
    const formData = new FormData();
    formData.append("Id", editFormData?.id)
    formData.append("name", editFormData?.name);
    formData.append("amount", editFormData?.amount);
    formData.append("imageUrl", editFormData?.imageUrl);
    formData.append("latitude", editFormData?.latitude);
    formData.append("longitude", editFormData?.longitude);

    try {
      const response = await axios.put(
        `${Api_Url}api/v1/PdExpense/single-update/${id}`,
        formData,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
              "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data?.succeeded) {
        SuccessToast("Updated Successfully")
        fetchExpenseData()
        setIsEditModalOpen(false)
      }
    } catch (error) {
      ErrorToast("Something went wrong")
      return error;
    }
  };



  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-end">
          <button
            className="btn btn-primary submit-btn"
            onClick={() => setIsModalOpen(true)}
          >
            Add Expense
          </button>
        </div>
      </div>

      <div className="row mt-4">
        {expenseData.length > 0 &&
          expenseData.map((item) => (
            <div className="col-lg-4 col-md-6 col-sm-12 col-12" key={item.id}>
              <div className="card py-4 px-3">
                <div className="d-flex align-items-center gap-1">
                  <h6>Name: </h6>
                  <p>{item.name}</p>
                </div>
                <div className="d-flex align-items-center gap-1">
                  <h6>Description: </h6>
                  <p>{item.descriptionText || "N/A"}</p>
                </div>
                <div className="d-flex align-items-center gap-1">
                  <h6>Amount: </h6>
                  <p>{item.amount || "N/A"}</p>
                </div>
                <div className="d-flex justify-content-between mt-3">
                  <div className="d-flex align-items-center justify-content-end gap-1">
                    <MdEdit
                      cursor="pointer"
                      size={28}
                      onClick={() => HandleShowFunction(item.id)}
                    />
                  </div>
                  <div className="d-flex align-items-center justify-content-end gap-1">
                    <MdDelete
                      cursor="pointer"
                      size={28}
                      onClick={() => handleDeleteClick(item.id)}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>

      {/* Add Expense Modal */}
      <Modal
        title="Add Expense"
        centered
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <button
            key="submit"
            className="btn btn-primary submit-btn"
            type="submit"
            onClick={handleSubmit}
          >
            Submit
          </button>,
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body">
          <form>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Name</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter Name"
                    value={formExpenseData.Name}
                    onChange={(event) =>
                      setFormExpenseData({
                        ...formExpenseData,
                        Name: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Amount</label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Enter Amount"
                    value={formExpenseData.Amount}
                    onChange={(event) =>
                      setFormExpenseData({
                        ...formExpenseData,
                        Amount: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label className="col-form-label">Description</label>
                  <textarea
                    className="form-control"
                    rows={5}
                    placeholder="Enter Expense Description"
                    value={formExpenseData.DescriptionText}
                    onChange={(event) =>
                      setFormExpenseData({
                        ...formExpenseData,
                        DescriptionText: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <input
                  type="file"
                  accept="image/*"
                  name=""
                  id="upload-image"
                  onChange={handleImageChange}
                />
                {/* {formExpenseData.ImageUrl !== null ? (
                  <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
                    {formExpenseData?.ImageUrl?.name}{" "}
                    <MdCancel
                      size={20}
                      onClick={() =>
                        setFormExpenseData((prev) => ({
                          ...prev,
                          ImageUrl: null,
                        }))
                      }
                    />
                  </p>
                ) : (
                  <label htmlFor="upload-image" className="">
                    <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
                      <FaUpload size={20} /> Click to Upload
                    </p>
                  </label>
                )} */}
              </div>
            </div>
          </form>
        </div>
      </Modal>

      {/* Edit Modal */}

      <Modal
        title="Add Expense"
        centered
        open={isEditModalOpen}
        onOk={() => setIsEditModalOpen(false)}
        onCancel={() => setIsEditModalOpen(false)}
        footer={[
          <button
            key="submit"
            className="btn btn-primary submit-btn"
            type="submit"
            onClick={() => handleUpdate(editFormData.id)}
          >
            Submit
          </button>,
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body">
          <form>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Name</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter Name"
                    value={editFormData.name}
                    onChange={(event) =>
                      setEditFormData({
                        ...editFormData,
                        name: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Amount</label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Enter Amount"
                    value={editFormData.amount}
                    onChange={(event) =>
                      setEditFormData({
                        ...editFormData,
                        amount: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
           
            <div className="row">
              <div className="col-sm-12">
                <input
                  type="file"
                  accept="image/*"
                  name=""
                  id="upload-image"
                  onChange={handleEditImageChange}
                  hidden
                />
                {editFormData.imageUrl ? (
                  <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
                    {editFormData?.imageUrl?.name}{" "}
                    <MdCancel
                      size={20}
                      onClick={() =>
                        setEditFormData((prev) => ({
                          ...prev,
                          imageUrl: null,
                        }))
                      }
                    />
                  </p>
                ) : (
                  <label htmlFor="upload-image" className="">
                    <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
                      <FaUpload size={20} /> Click to Upload
                    </p>
                  </label>
                )}
              </div>
            </div>
          </form>
        </div>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        title="Confirm Delete"
        centered
        open={isDeleteModalOpen}
        onOk={handleConfirmDelete}
        onCancel={() => setIsDeleteModalOpen(false)}
        okText="Confirm"
        cancelText="Cancel"
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <p>Are you sure you want to delete this expense?</p>
      </Modal>
    </div>
  );
};

export default PdExpense;

// import axios from "axios";
// import React from "react";
// import { Api_Url } from "../../config/config";
// import { FaUpload } from "react-icons/fa6";
// import { MdCancel, MdDelete } from "react-icons/md";
// import { Modal } from "antd";

// const PdExpense = ({ profileId }) => {
//   const [expenseData, setExpenseData] = React.useState([]);
//   const [formExpenseData, setFormExpenseData] = React.useState({
//     Name: "", DescriptionText: "", Amount: 0, ImageUrl: null, Latitude: "", Longitude: "", BusinessPdProfileId: profileId, BusinessId: "", DescriptionValue: ""
//   });
//   const [isModalOpen, setIsModalOpen] = React.useState(false);

//   const handleImageChange = event => {
//     setFormExpenseData(prev => ({
//       ...prev,
//       ImageUrl: event.target.files[0]
//     }))
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     fetchCurentLocation();

//     const formData = new FormData();
//     formData.append("Name", formExpenseData.Name)
//     formData.append("DescriptionText", formExpenseData.DescriptionText)
//     formData.append("Amount", formExpenseData.Amount)
//     formData.append("ImageUrl", formExpenseData.ImageUrl)
//     formData.append("Latitude", formExpenseData.Latitude)
//     formData.append("Longitude", formExpenseData.Longitude)
//     formData.append("BusinessPdProfileId", formExpenseData.BusinessPdProfileId)
//     formData.append("BusinessId", formExpenseData.BusinessId)
//     formData.append("DescriptionValue", formExpenseData.DescriptionValue);

//     const { data } = await axios.post(Api_Url + "api/v1/PdExpense", formData, {
//       headers: {
//         Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
//       }
//     });
//     if (data.succeeded) {
//       fetchExpenseData();
//       setIsModalOpen(false);
//       setFormExpenseData(prev => ({
//         ...prev,
//         Name: "", DescriptionText: "", Amount: 0, ImageUrl: null, Latitude: "", Longitude: "", BusinessPdProfileId: profileId, BusinessId: "", DescriptionValue: ""
//       }))
//     }
//   };

//   const handleDelete = async (id) => {
//     try {
//       const { data } = await axios.delete(Api_Url + "api/v1/PdExpense/" + id, {
//         headers: {
//           Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
//         }
//       });
//       fetchExpenseData();
//       console.log(data);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const fetchExpenseData = async () => {
//     const { data } = await axios.get(Api_Url + `api/v1/PdExpense/getby-pd-profileid/${profileId}`, {
//       headers: {
//         Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
//       }
//     });
//     setExpenseData(data.data)
//   };

//   const fetchCurentLocation = () => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {
//         const { latitude, longitude } = position.coords;
//         setFormExpenseData(prev => ({ ...prev, Latitude: latitude, Longitude: longitude }))
//       });
//     } else {
//       return "Geolocation is not supported by this browser."
//     }
//   };

//   React.useEffect(() => {
//     fetchExpenseData();
//     fetchCurentLocation();
//   }, []);

//   return (
//     <div className="container mt-3">
//       <div className="row">
//         <div className="col-12 d-flex align-items-center justify-content-end">
//           <button className="btn btn-primary submit-btn" onClick={() => setIsModalOpen(true)}>Add Expense</button>
//         </div>
//       </div>

//       <div className="row mt-4">
//         {expenseData.length > 0 && expenseData.map(item => (
//           <div className="col-lg-4 col-md-6 col-sm-12 col-12">
//             <div className="card py-4 px-3">
//               <div className="d-flex align-items-center gap-1">
//                 <h6 className="">Name: </h6>
//                 <p>{item?.name}</p>
//               </div>
//               <div className="d-flex align-items-center gap-1">
//                 <h6 className="">Description: </h6>
//                 <p>{item?.descriptionText || "N/A"}</p>
//               </div>
//               <div className="d-flex align-items-center gap-1">
//                 <h6 className="">Amount: </h6>
//                 <p>{item?.amount || "N/A"}</p>
//               </div>
//               <div className="d-flex align-items-center justify-content-end gap-1">
//                 <MdDelete cursor={"pointer"} size={28} onClick={() => handleDelete(item.id)} />
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Add Expense Modal */}
//       <Modal
//         title="Add Expense"
//         centered
//         open={isModalOpen}
//         onOk={() => setIsModalOpen(false)}
//         onCancel={() => setIsModalOpen(false)}
//         footer={[
//           <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleSubmit}>Submit</button>
//         ]}
//         width={600}
//         mask={false}
//         maskClosable={false}
//         closeIcon={<span style={{ color: 'red' }}>X</span>}
//       >
//         <div className="modal-body">
//           <form>
//             <div className="row">
//               <div className="col-sm-6">
//                 <div className="input-block mb-3">
//                   <label className="col-form-label">
//                     Name
//                   </label>
//                   <input className="form-control" type="text" placeholder="Enter Name" value={formExpenseData.Name} onChange={event => setFormExpenseData({ ...formExpenseData, Name: event.target.value })} />
//                 </div>
//               </div>
//               <div className="col-sm-6">
//                 <div className="input-block mb-3">
//                   <label className="col-form-label">
//                     Amount
//                   </label>
//                   <input className="form-control" type="number" placeholder="Enter Amount" value={formExpenseData.Amount} onChange={event => setFormExpenseData({ ...formExpenseData, Amount: event.target.value })} />
//                 </div>
//               </div>
//             </div>
//             <div className="row">
//               <div className="col-sm-12">
//                 <div className="input-block mb-3">
//                   <label className="col-form-label">
//                     Description
//                   </label>
//                   <textarea className="form-control" rows={5} placeholder="Enter Expense Description" value={formExpenseData.DescriptionText} onChange={event => setFormExpenseData({ ...formExpenseData, DescriptionText: event.target.value })} />
//                 </div>
//               </div>
//             </div>
//             <div className="row">
//               <div className="col-sm-12">
//                 <input type="file" accept="image/*" name="" id="upload-image" onChange={handleImageChange} hidden />
//                 {
//                   formExpenseData.ImageUrl !== null ? <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
//                     {formExpenseData?.ImageUrl?.name} <MdCancel size={20} onClick={() => setFormExpenseData(prev => ({ ...prev, ImageUrl: null }))} />
//                   </p> : <label htmlFor="upload-image" className="">
//                     <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
//                       <FaUpload size={20} /> Click to Upload
//                     </p>
//                   </label>
//                 }
//               </div>
//             </div>
//           </form>
//         </div>
//       </Modal>
//     </div >
//   )
// }

// export default PdExpense

// import axios from "axios";
// import React from "react";
// import { Api_Url } from "../../config/config";
// import { FaUpload } from "react-icons/fa6";
// import { MdCancel, MdDelete, MdEdit, MdUpdate } from "react-icons/md";
// import { Modal } from "antd";
// import { ErrorToast, SuccessToast } from "../../views/ToastComponent";

// const PdExpense = ({ profileId }) => {
//   const [expenseData, setExpenseData] = React.useState([]);
//   const [formExpenseData, setFormExpenseData] = React.useState({
//     Name: "",
//     DescriptionText: "",
//     Amount: 0,
//     ImageUrl: null,
//     Latitude: "",
//     Longitude: "",
//     BusinessPdProfileId: profileId,
//     BusinessId: "",
//     DescriptionValue: "",
//   });
//   const [isModalOpen, setIsModalOpen] = React.useState(false);
//   const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);
//   const [itemToDelete, setItemToDelete] = React.useState(null);

//   const handleImageChange = (event) => {
//     setFormExpenseData((prev) => ({
//       ...prev,
//       ImageUrl: event.target.files[0],
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     fetchCurentLocation();

//     const formData = new FormData();
//     formData.append("Name", formExpenseData.Name);
//     formData.append("DescriptionText", formExpenseData.DescriptionText);
//     formData.append("Amount", formExpenseData.Amount);
//     formData.append("ImageUrl", formExpenseData.ImageUrl);
//     formData.append("Latitude", formExpenseData.Latitude);
//     formData.append("Longitude", formExpenseData.Longitude);
//     formData.append("BusinessPdProfileId", formExpenseData.BusinessPdProfileId);
//     formData.append("BusinessId", formExpenseData.BusinessId);
//     formData.append("DescriptionValue", formExpenseData.DescriptionValue);

//     const { data } = await axios.post(Api_Url + "api/v1/PdExpense", formData, {
//       headers: {
//         Authorization:
//           "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
//       },
//     });
//     if (data.succeeded) {
//       fetchExpenseData();
//       setIsModalOpen(false);
//       setFormExpenseData((prev) => ({
//         ...prev,
//         Name: "",
//         DescriptionText: "",
//         Amount: 0,
//         ImageUrl: null,
//         Latitude: "",
//         Longitude: "",
//         BusinessPdProfileId: profileId,
//         BusinessId: "",
//         DescriptionValue: "",
//       }));
//     }
//   };

//   const handleDeleteClick = (id) => {
//     setItemToDelete(id);
//     setIsDeleteModalOpen(true);
//   };

//   const handleConfirmDelete = async () => {
//     try {
//       const { data } = await axios.delete(
//         Api_Url + "api/v1/PdExpense/" + itemToDelete,
//         {
//           headers: {
//             Authorization:
//               "Bearer " +
//               JSON.parse(sessionStorage.getItem("user"))?.accessToken,
//           },
//         }
//       );
//       if (data.succeeded) {
//         fetchExpenseData();
//       }
//       SuccessToast("Deleted Successfully");
//     } catch (error) {
//       ErrorToast("Something went wrong");
//       console.log(error);
//     } finally {
//       setIsDeleteModalOpen(false);
//       setItemToDelete(null);
//     }
//   };

//   const fetchExpenseData = async () => {
//     const { data } = await axios.get(
//       Api_Url + `api/v1/PdExpense/getby-pd-profileid/${profileId}`,
//       {
//         headers: {
//           Authorization:
//             "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
//         },
//       }
//     );
//     setExpenseData(data.data);
//   };

//   const fetchCurentLocation = () => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {
//         const { latitude, longitude } = position.coords;
//         setFormExpenseData((prev) => ({
//           ...prev,
//           Latitude: latitude,
//           Longitude: longitude,
//         }));
//       });
//     } else {
//       return "Geolocation is not supported by this browser.";
//     }
//   };

//   React.useEffect(() => {
//     fetchExpenseData();
//     fetchCurentLocation();
//   }, []);

//   // singleUser Details Show In Modal

//   const handleShowDetail = async (id) => {
//     console.log("id", id);
//     try {
//       const response = await axios.get(`${Api_Url}api/v1/PdExpense/${id}`, {
//         headers: {
//           Authorization:
//             "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
//         },
//       });
//       setFormExpenseData(response?.data?.data);
//       setIsEditModalOpen(true);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   return (
//     <div className="container mt-3">
//       <div className="row">
//         <div className="col-12 d-flex align-items-center justify-content-end">
//           <button
//             className="btn btn-primary submit-btn"
//             onClick={() => setIsModalOpen(true)}
//           >
//             Add Expense
//           </button>
//         </div>
//       </div>

//       <div className="row mt-4">
//         {expenseData.length > 0 &&
//           expenseData.map((item) => (
//             <div className="col-lg-4 col-md-6 col-sm-12 col-12" key={item.id}>
//               <div className="card py-4 px-3">
//                 <div className="d-flex align-items-center gap-1">
//                   <h6>Name: </h6>
//                   <p>{item.name}</p>
//                 </div>
//                 <div className="d-flex align-items-center gap-1">
//                   <h6>Description: </h6>
//                   <p>{item.descriptionText || "N/A"}</p>
//                 </div>
//                 <div className="d-flex align-items-center gap-1">
//                   <h6>Amount: </h6>
//                   <p>{item.amount || "N/A"}</p>
//                 </div>
//                 <div className="d-flex justify-content-between mt-3">
//                   <div className="d-flex align-items-center justify-content-end gap-1">
//                     <MdDelete
//                       cursor="pointer"
//                       size={28}
//                       onClick={() => handleDeleteClick(item.id)}
//                     />
//                   </div>
//                   <div className="d-flex align-items-center justify-content-end gap-1">
//                     <MdEdit
//                       cursor="pointer"
//                       size={28}
//                       onClick={() => handleShowDetail(item.id)}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//       </div>

//       {/* Add Expense Modal */}
//       <Modal
//         title="Add Expense"
//         centered
//         open={isModalOpen}
//         onOk={() => setIsModalOpen(false)}
//         onCancel={() => setIsModalOpen(false)}
//         footer={[
//           <button
//             key="submit"
//             className="btn btn-primary submit-btn"
//             type="submit"
//             onClick={handleSubmit}
//           >
//             Submit
//           </button>,
//         ]}
//         width={600}
//         mask={false}
//         maskClosable={false}
//         closeIcon={<span style={{ color: "red" }}>X</span>}
//       >
//         <div className="modal-body">
//           <form>
//             <div className="row">
//               <div className="col-sm-6">
//                 <div className="input-block mb-3">
//                   <label className="col-form-label">Name</label>
//                   <input
//                     className="form-control"
//                     type="text"
//                     placeholder="Enter Name"
//                     value={formExpenseData.Name}
//                     onChange={(event) =>
//                       setFormExpenseData({
//                         ...formExpenseData,
//                         Name: event.target.value,
//                       })
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="col-sm-6">
//                 <div className="input-block mb-3">
//                   <label className="col-form-label">Amount</label>
//                   <input
//                     className="form-control"
//                     type="number"
//                     placeholder="Enter Amount"
//                     value={formExpenseData.Amount}
//                     onChange={(event) =>
//                       setFormExpenseData({
//                         ...formExpenseData,
//                         Amount: event.target.value,
//                       })
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="row">
//               <div className="col-sm-12">
//                 <div className="input-block mb-3">
//                   <label className="col-form-label">Description</label>
//                   <textarea
//                     className="form-control"
//                     rows={5}
//                     placeholder="Enter Expense Description"
//                     value={formExpenseData.DescriptionText}
//                     onChange={(event) =>
//                       setFormExpenseData({
//                         ...formExpenseData,
//                         DescriptionText: event.target.value,
//                       })
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="row">
//               <div className="col-sm-12">
//                 <input
//                   type="file"
//                   accept="image/*"
//                   name=""
//                   id="upload-image"
//                   onChange={handleImageChange}
//                   hidden
//                 />
//                 {formExpenseData.ImageUrl !== null ? (
//                   <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
//                     {formExpenseData?.ImageUrl?.name}{" "}
//                     <MdCancel
//                       size={20}
//                       onClick={() =>
//                         setFormExpenseData((prev) => ({
//                           ...prev,
//                           ImageUrl: null,
//                         }))
//                       }
//                     />
//                   </p>
//                 ) : (
//                   <label htmlFor="upload-image" className="">
//                     <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
//                       <FaUpload size={20} /> Click to Upload
//                     </p>
//                   </label>
//                 )}
//               </div>
//             </div>
//           </form>
//         </div>
//       </Modal>

//       {/* Edit Expense Modal */}

//       <Modal
//         title="Edit Expense"
//         centered
//         open={isEditModalOpen}
//         onOk={() => setIsEditModalOpen(false)}
//         onCancel={() => setIsEditModalOpen(false)}
//         footer={[
//           <button
//             key="submit"
//             className="btn btn-primary submit-btn"
//             type="submit"
//             onClick={handleSubmit}
//           >
//             Submit
//           </button>,
//         ]}
//         width={600}
//         mask={false}
//         maskClosable={false}
//         closeIcon={<span style={{ color: "red" }}>X</span>}
//       >
//         <div className="modal-body">
//           <form>
//             <div className="row">
//               <div className="col-sm-6">
//                 <div className="input-block mb-3">
//                   <label className="col-form-label">Name</label>
//                   <input
//                     className="form-control"
//                     type="text"
//                     placeholder="Enter Name"
//                     value={formExpenseData.Name}
//                     onChange={(event) =>
//                       setFormExpenseData({
//                         ...formExpenseData,
//                         Name: event.target.value,
//                       })
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="col-sm-6">
//                 <div className="input-block mb-3">
//                   <label className="col-form-label">Amount</label>
//                   <input
//                     className="form-control"
//                     type="number"
//                     placeholder="Enter Amount"
//                     value={formExpenseData.Amount}
//                     onChange={(event) =>
//                       setFormExpenseData({
//                         ...formExpenseData,
//                         Amount: event.target.value,
//                       })
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="row">
//               <div className="col-sm-12">
//                 <div className="input-block mb-3">
//                   <label className="col-form-label">Description</label>
//                   <textarea
//                     className="form-control"
//                     rows={5}
//                     placeholder="Enter Expense Description"
//                     value={formExpenseData.DescriptionText}
//                     onChange={(event) =>
//                       setFormExpenseData({
//                         ...formExpenseData,
//                         DescriptionText: event.target.value,
//                       })
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="row">
//               <div className="col-sm-12">
//                 <input
//                   type="file"
//                   accept="image/*"
//                   name=""
//                   id="upload-image"
//                   onChange={handleImageChange}
//                   hidden
//                 />
//                 {formExpenseData.ImageUrl !== null ? (
//                   <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
//                     {formExpenseData?.ImageUrl?.name}{" "}
//                     <MdCancel
//                       size={20}
//                       onClick={() =>
//                         setFormExpenseData((prev) => ({
//                           ...prev,
//                           ImageUrl: null,
//                         }))
//                       }
//                     />
//                   </p>
//                 ) : (
//                   <label htmlFor="upload-image" className="">
//                     <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
//                       <FaUpload size={20} /> Click to Upload
//                     </p>
//                   </label>
//                 )}
//               </div>
//             </div>
//           </form>
//         </div>
//       </Modal>

//       {/* Delete Confirmation Modal */}
//       <Modal
//         title="Confirm Delete"
//         centered
//         open={isDeleteModalOpen}
//         onOk={handleConfirmDelete}
//         onCancel={() => setIsDeleteModalOpen(false)}
//         okText="Confirm"
//         cancelText="Cancel"
//         mask={false}
//         maskClosable={false}
//         closeIcon={<span style={{ color: "red" }}>X</span>}
//       >
//         <p>Are you sure you want to delete this expense?</p>
//       </Modal>
//     </div>
//   );
// };

// export default PdExpense;

// import axios from "axios";
// import React from "react";
// import { Api_Url } from "../../config/config";
// import { FaUpload } from "react-icons/fa6";
// import { MdCancel, MdDelete } from "react-icons/md";
// import { Modal } from "antd";

// const PdExpense = ({ profileId }) => {
//   const [expenseData, setExpenseData] = React.useState([]);
//   const [formExpenseData, setFormExpenseData] = React.useState({
//     Name: "", DescriptionText: "", Amount: 0, ImageUrl: null, Latitude: "", Longitude: "", BusinessPdProfileId: profileId, BusinessId: "", DescriptionValue: ""
//   });
//   const [isModalOpen, setIsModalOpen] = React.useState(false);

//   const handleImageChange = event => {
//     setFormExpenseData(prev => ({
//       ...prev,
//       ImageUrl: event.target.files[0]
//     }))
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     fetchCurentLocation();

//     const formData = new FormData();
//     formData.append("Name", formExpenseData.Name)
//     formData.append("DescriptionText", formExpenseData.DescriptionText)
//     formData.append("Amount", formExpenseData.Amount)
//     formData.append("ImageUrl", formExpenseData.ImageUrl)
//     formData.append("Latitude", formExpenseData.Latitude)
//     formData.append("Longitude", formExpenseData.Longitude)
//     formData.append("BusinessPdProfileId", formExpenseData.BusinessPdProfileId)
//     formData.append("BusinessId", formExpenseData.BusinessId)
//     formData.append("DescriptionValue", formExpenseData.DescriptionValue);

//     const { data } = await axios.post(Api_Url + "api/v1/PdExpense", formData, {
//       headers: {
//         Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
//       }
//     });
//     if (data.succeeded) {
//       fetchExpenseData();
//       setIsModalOpen(false);
//       setFormExpenseData(prev => ({
//         ...prev,
//         Name: "", DescriptionText: "", Amount: 0, ImageUrl: null, Latitude: "", Longitude: "", BusinessPdProfileId: profileId, BusinessId: "", DescriptionValue: ""
//       }))
//     }
//   };

//   const handleDelete = async (id) => {
//     try {
//       const { data } = await axios.delete(Api_Url + "api/v1/PdExpense/" + id, {
//         headers: {
//           Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
//         }
//       });
//       fetchExpenseData();
//       console.log(data);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const fetchExpenseData = async () => {
//     const { data } = await axios.get(Api_Url + `api/v1/PdExpense/getby-pd-profileid/${profileId}`, {
//       headers: {
//         Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
//       }
//     });
//     setExpenseData(data.data)
//   };

//   const fetchCurentLocation = () => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {
//         const { latitude, longitude } = position.coords;
//         setFormExpenseData(prev => ({ ...prev, Latitude: latitude, Longitude: longitude }))
//       });
//     } else {
//       return "Geolocation is not supported by this browser."
//     }
//   };

//   React.useEffect(() => {
//     fetchExpenseData();
//     fetchCurentLocation();
//   }, []);

//   return (
//     <div className="container mt-3">
//       <div className="row">
//         <div className="col-12 d-flex align-items-center justify-content-end">
//           <button className="btn btn-primary submit-btn" onClick={() => setIsModalOpen(true)}>Add Expense</button>
//         </div>
//       </div>

//       <div className="row mt-4">
//         {expenseData.length > 0 && expenseData.map(item => (
//           <div className="col-lg-4 col-md-6 col-sm-12 col-12">
//             <div className="card py-4 px-3">
//               <div className="d-flex align-items-center gap-1">
//                 <h6 className="">Name: </h6>
//                 <p>{item?.name}</p>
//               </div>
//               <div className="d-flex align-items-center gap-1">
//                 <h6 className="">Description: </h6>
//                 <p>{item?.descriptionText || "N/A"}</p>
//               </div>
//               <div className="d-flex align-items-center gap-1">
//                 <h6 className="">Amount: </h6>
//                 <p>{item?.amount || "N/A"}</p>
//               </div>
//               <div className="d-flex align-items-center justify-content-end gap-1">
//                 <MdDelete cursor={"pointer"} size={28} onClick={() => handleDelete(item.id)} />
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Add Expense Modal */}
//       <Modal
//         title="Add Expense"
//         centered
//         open={isModalOpen}
//         onOk={() => setIsModalOpen(false)}
//         onCancel={() => setIsModalOpen(false)}
//         footer={[
//           <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleSubmit}>Submit</button>
//         ]}
//         width={600}
//         mask={false}
//         maskClosable={false}
//         closeIcon={<span style={{ color: 'red' }}>X</span>}
//       >
//         <div className="modal-body">
//           <form>
//             <div className="row">
//               <div className="col-sm-6">
//                 <div className="input-block mb-3">
//                   <label className="col-form-label">
//                     Name
//                   </label>
//                   <input className="form-control" type="text" placeholder="Enter Name" value={formExpenseData.Name} onChange={event => setFormExpenseData({ ...formExpenseData, Name: event.target.value })} />
//                 </div>
//               </div>
//               <div className="col-sm-6">
//                 <div className="input-block mb-3">
//                   <label className="col-form-label">
//                     Amount
//                   </label>
//                   <input className="form-control" type="number" placeholder="Enter Amount" value={formExpenseData.Amount} onChange={event => setFormExpenseData({ ...formExpenseData, Amount: event.target.value })} />
//                 </div>
//               </div>
//             </div>
//             <div className="row">
//               <div className="col-sm-12">
//                 <div className="input-block mb-3">
//                   <label className="col-form-label">
//                     Description
//                   </label>
//                   <textarea className="form-control" rows={5} placeholder="Enter Expense Description" value={formExpenseData.DescriptionText} onChange={event => setFormExpenseData({ ...formExpenseData, DescriptionText: event.target.value })} />
//                 </div>
//               </div>
//             </div>
//             <div className="row">
//               <div className="col-sm-12">
//                 <input type="file" accept="image/*" name="" id="upload-image" onChange={handleImageChange} hidden />
//                 {
//                   formExpenseData.ImageUrl !== null ? <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
//                     {formExpenseData?.ImageUrl?.name} <MdCancel size={20} onClick={() => setFormExpenseData(prev => ({ ...prev, ImageUrl: null }))} />
//                   </p> : <label htmlFor="upload-image" className="">
//                     <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
//                       <FaUpload size={20} /> Click to Upload
//                     </p>
//                   </label>
//                 }
//               </div>
//             </div>
//           </form>
//         </div>
//       </Modal>
//     </div >
//   )
// }

// export default PdExpense
